import { toDateString } from "src/utils/date";
import { calendarYmdInTimeZone } from "src/utils/timezone";

export const Rates = [
  // Source: https://www.irs.gov/tax-professionals/standard-mileage-rates
  // From inclusive, to exclusive — { from: 'YYYY-MM-DD', to: 'YYYY-MM-DD', value: '$/mile' }
  { from: "2026-07-01", to: "2027-01-01", value: 0.76 },
  { from: "2026-01-01", to: "2026-07-01", value: 0.725 },
  { from: "2025-01-01", to: "2026-01-01", value: 0.7 },
  { from: "2024-01-01", to: "2025-01-01", value: 0.67 },
  { from: "2023-01-01", to: "2024-01-01", value: 0.655 },
  { from: "2022-07-01", to: "2023-01-01", value: 0.625 },
  { from: "2022-01-01", to: "2022-07-01", value: 0.585 },
];

/** IRS rate bracket lookup from a calendar `yyyy-mm-dd` string. */
export function getRateForYmd(ymd: string): number | undefined {
  for (const { from, to, value } of Rates) {
    if (from <= ymd && ymd < to) return value;
  }
}

export function getRate(date?: Date): number | undefined {
  if (!date) return;
  return getRateForYmd(toDateString(date));
}

/**
 * Miles from dollar amount using the IRS rate for the calendar day in the user's IANA timezone
 * (matches server-side Schedule C / report boundaries).
 */
export function getMileageInTimeZone(
  date: Date | undefined,
  amount: number | undefined,
  timeZone: string
): number {
  if (!date || amount == null) return 0;
  const ymd = calendarYmdInTimeZone(date, timeZone);
  const rate = getRateForYmd(ymd);
  if (rate) return amount / rate;
  return 0;
}

export function getMileage(date?: Date, amount?: number): number {
  if (date && amount) {
    const rate = getRate(date);
    if (rate) return amount / rate;
  }

  return 0;
}
